import syncService from '../services/sync.service.js'

import httpUtility from '../utils/http.utility.js'

import { useToast } from '../composables/useToast.js'

import { t } from '@/i18n'

const toast = useToast()

async function getGenerations() {
  try {
    return await syncService.get.generations()
  } catch (err) {
    toast.error(httpUtility.error.message(err, t('common.errors.sync')))
    return null
  }
}

class SyncController {
  get = {
    /**
     * Read the live generation counters for the caller's accessible accounts.
     * Returns the generations map on success, `null` on failure (controller
     * toasts the error).
     *
     * @returns {Promise<Record<string, Record<string, number>>|null>}
     */
    async generations() {
      return getGenerations()
    },
  }
}

export default new SyncController()
